import { render, staticRenderFns } from "./CouponDetailModal.vue?vue&type=template&id=1cd70af0&scoped=true&"
import script from "./CouponDetailModal.vue?vue&type=script&lang=js&"
export * from "./CouponDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./CouponDetailModal.vue?vue&type=style&index=0&id=1cd70af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd70af0",
  null
  
)

/* custom blocks */
import block0 from "./CouponDetailModal.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "CouponDetailModal.vue"
export default component.exports